import React from 'react'
import './GalaxyModalView.css'
import universeRawData from '../data/universe.json'
import { reframeGalaxyData } from '../../processes/functions'
import TabView from './TabView'

function GalaxyModalView({id}) {
  const galaxyData = universeRawData[id]

  const reframeData = reframeGalaxyData(galaxyData)
  


  return (
    <div style={{color:"white"}}>
        <div className="galaxyTitle modalViewDiv no_border">
            <p>{galaxyData.data.name}</p>
        </div>


        <TabView data={reframeData} />
        

    </div>
  )
}

export default GalaxyModalView